import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';

import ReviewChartBar from 'components/reviewV2/ReviewChart/ReviewChartBar';

import './reviewChart.scss';

export function ReviewChart({ ratingCounts = [], totalReviews }) {
	const ratings = useMemo(
		() => sortBy(ratingCounts, (rating) => -1 * rating.rating),
		[ratingCounts],
	);
	return (
		<div className="review-chart">
			{ratings.map((rating) => (
				<ReviewChartBar
					rating={rating.rating}
					percentRating={parseInt(
						(rating.count / totalReviews) * 100,
					)}
					reviewCount={rating.count}
					key={rating.rating}
				/>
			))}
		</div>
	);
}

ReviewChart.propTypes = {
	/** List of rating count objects that contain a rating (1-5) and a count */
	ratingCounts: PropTypes.arrayOf(
		PropTypes.shape({
			rating: PropTypes.number.isRequired,
			count: PropTypes.number.isRequired,
		}),
	),
	/** Total number of reviews */
	totalReviews: PropTypes.number.isRequired,
};

export default ReviewChart;
